const TNS = {
  // URLs
  START_BUILDING_URL: 'https://console.sharetribe.com/new',
  LOGIN_URL: 'https://console.sharetribe.com/login',

  // Pricing
  BUILD_PRICE: '39',
  LITE_MONTHLY_PRICE: '139',
  LITE_YEARLY_PRICE: '99',
  PRO_MONTHLY_PRICE: '249',
  PRO_YEARLY_PRICE: '199',
  EXTEND_MONTHLY_PRICE: '369',
  EXTEND_YEARLY_PRICE: '299',
};

// Convert the prices to numbers and multiply the monthly price by 12
TNS.LITE_MONTHLY_TOTAL = Number(TNS.LITE_MONTHLY_PRICE) * 12;
TNS.LITE_YEARLY_TOTAL = Number(TNS.LITE_YEARLY_PRICE) * 12;

TNS.PRO_MONTHLY_TOTAL = Number(TNS.PRO_MONTHLY_PRICE) * 12;
TNS.PRO_YEARLY_TOTAL = Number(TNS.PRO_YEARLY_PRICE) * 12;

TNS.EXTEND_MONTHLY_TOTAL = Number(TNS.EXTEND_MONTHLY_PRICE) * 12;
TNS.EXTEND_YEARLY_TOTAL = Number(TNS.EXTEND_YEARLY_PRICE) * 12;

// Calculating the difference and percentage and adding them to TNS
TNS.LITE_YEARLY_DISCOUNT = TNS.LITE_MONTHLY_TOTAL - TNS.LITE_YEARLY_TOTAL;
TNS.LITE_YEARLY_DISCOUNT_PERCENTAGE = (
  ((TNS.LITE_MONTHLY_TOTAL - TNS.LITE_YEARLY_TOTAL) / TNS.LITE_MONTHLY_TOTAL) *
  100
).toFixed(0);

TNS.PRO_YEARLY_DISCOUNT = TNS.PRO_MONTHLY_TOTAL - TNS.PRO_YEARLY_TOTAL;
TNS.PRO_YEARLY_DISCOUNT_PERCENTAGE = (
  ((TNS.PRO_MONTHLY_TOTAL - TNS.PRO_YEARLY_TOTAL) / TNS.PRO_MONTHLY_TOTAL) *
  100
).toFixed(0);

TNS.EXTEND_YEARLY_DISCOUNT = TNS.EXTEND_MONTHLY_TOTAL - TNS.EXTEND_YEARLY_TOTAL;
TNS.EXTEND_YEARLY_DISCOUNT_PERCENTAGE = (
  ((TNS.EXTEND_MONTHLY_TOTAL - TNS.EXTEND_YEARLY_TOTAL) / TNS.EXTEND_MONTHLY_TOTAL) *
  100
).toFixed(0);

export { TNS };
